import { render, staticRenderFns } from "./RejectionType.vue?vue&type=template&id=b9491a02&scoped=true&"
import script from "./RejectionType.vue?vue&type=script&lang=js&"
export * from "./RejectionType.vue?vue&type=script&lang=js&"
import style0 from "./RejectionType.vue?vue&type=style&index=0&id=b9491a02&prod&lang=css&"
import style1 from "./RejectionType.vue?vue&type=style&index=1&id=b9491a02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9491a02",
  null
  
)

export default component.exports